import React from 'react'
import Link from '../Link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import {
  ipOuterContainer,
  ipInnerContainer,
  ipColumnContainer,
  ipHeadingContainer,
  ipColumn,
  ipDark,
  ipTextContainer,
  ipHeadingImageContainer,
  defaultButtonStyle,
  altButtonStyle,
  defaultButtonStyleA,
  defaultButtonStyleB,
} from './index.module.css'

import { isSvgOrGif } from '../../utils'

const IPHero = ({
  title,
  subtitle,
  components,
  isDarkTheme,
  hideTitle,
  backgroundColor,
  images,
}) => {
  const backgroundImage = images ? images[0] : []
  const defaultBackgroundColor = isDarkTheme ? '#000' : '#F8F8F8'
  return (
    <div
      className={isDarkTheme ? ipDark : ''}
      style={{
        backgroundColor: backgroundColor
          ? backgroundColor
          : defaultBackgroundColor,
      }}
    >
      <div className={ipOuterContainer}>
        {backgroundImage &&
          (isSvgOrGif(backgroundImage.file.url) ? (
            <div className={ipHeadingImageContainer}>
              <img
                src={backgroundImage.file.url}
                alt={backgroundImage.description}
              />
            </div>
          ) : (
            <div className={ipHeadingImageContainer}>
              <GatsbyImage
                image={getImage(backgroundImage.iphero)}
                alt={backgroundImage.description}
              />
            </div>
          ))}

        <div className={['container', ipInnerContainer].join(' ')}>
          {(hideTitle === null || hideTitle === false) && (
            <div className={ipHeadingContainer}>
              {title && <h1>{title}</h1>}
              {subtitle && <h2>{subtitle.subtitle}</h2>}
            </div>
          )}
          <div className={ipColumnContainer}>
            {components &&
              components.map(
                ({ ctaText, ctaUrl, ctaDefaultDisplay }, index) => {
                  return (
                    <div className={ipColumn} key={index}>
                      <div className={ipTextContainer}>
                        {ctaText && ctaUrl && (
                          <Link
                            className={[
                              ctaDefaultDisplay !== null && !ctaDefaultDisplay
                                ? altButtonStyle
                                : defaultButtonStyle,
                              index % 2 === 0
                                ? defaultButtonStyleA
                                : defaultButtonStyleB,
                            ].join(' ')}
                            to={ctaUrl}
                          >
                            {ctaText}
                          </Link>
                        )}
                      </div>
                    </div>
                  )
                }
              )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default IPHero
